import { Env, getProcessEnvironmentValue } from '@gif/shared-global';

interface AppConfig {
  oktaScript: string;
  feenApiUrl: string;
  oktaApiUrl: string;
  adobeReportingSuiteIds: string;
}

const environment = (getProcessEnvironmentValue('APP_ENV') || 'prod') as Env;

const appConfigs: { [key in Env]: AppConfig } = {
  local: {
    oktaScript: 'https://qa.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms-qa.mlbinfra.com/cms/api',
    oktaApiUrl: 'https://profile-qa.mlb.com',
    adobeReportingSuiteIds: 'devmlbglobal,devmlbplay',
  },
  preview: {
    oktaScript: 'https://qa.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms-qa.mlbinfra.com/cms/api',
    oktaApiUrl: ' https://profile-qa.mlb.com',
    adobeReportingSuiteIds: 'previewmlbglobal,previewmlbplay',
  },
  dev: {
    oktaScript: 'https://qa.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms-qa.mlbinfra.com/cms/api',
    oktaApiUrl: 'https://profile-qa.mlb.com',
    adobeReportingSuiteIds: 'devmlbglobal,devmlbplay',
  },
  qa: {
    oktaScript: 'https://qa.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms-qa.mlbinfra.com/cms/api',
    oktaApiUrl: 'https://profile-qa.mlb.com',
    adobeReportingSuiteIds: 'qamlbglobal,qamlbplay',
  },
  beta: {
    oktaScript:
      'https://beta.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms-qa.mlbinfra.com/cms/api',
    oktaApiUrl: 'https://profile.mlb.com',
    adobeReportingSuiteIds: 'betamlbglobal',
  },
  prod: {
    oktaScript: 'https://www.mlbstatic.com/mlb.com/vendor/mlb-okta/mlb-okta.js',
    feenApiUrl: 'https://feen.cms.mlbinfra.com/cms/api',
    oktaApiUrl: 'https://profile.mlb.com',
    adobeReportingSuiteIds: 'mlbglobal08',
  },
};

export const config = appConfigs[environment];
